// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSecondaryCoursesHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryCourseDTO from '../models/SecondaryCourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
    districtId: string | null | null;
    secondaryCourseId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
            districtId: null,
            secondaryCourseId: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    districtId: 'districtId',
    secondaryCourseId: 'secondaryCourseId',
}

interface Result extends ResultDTO {
    secondaryCourse: SecondaryCourseDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryCourse: [],
        },
        initValues);
    },
    secondaryCourse: 'secondaryCourse',
}

export { Request, Result };